import Vue from 'vue'
import App from './App.vue'
import Storage from 'vue-ls'
import router from './router'
import store from './store/'
import config from './defaultSettings'
import axios from 'axios'
import http from './http'
import moment from 'moment'
import VideoPlayer from 'vue-video-player'
import VueAliplayer from 'vue-aliplayer'
import Api from "@/interface/index"
import VueClipboard from 'vue-clipboard2'
import Base64 from 'js-base64';
 
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')

Vue.prototype.$Api = Api

Vue.prototype.$axios = axios;

Vue.use(Storage, config.storageOptions)
Vue.use(VideoPlayer, VueAliplayer,Base64)
Vue.use(VueClipboard)
import './router/routerChange'

Vue.config.productionTip = false

Vue.filter('dateformat', function(dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return moment(dataStr).format(pattern)
})

import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.less'
import {
  Button, message
} from 'ant-design-vue';
Vue.use(Button);
Vue.use(message)
Vue.use(Antd)

/**
 * css
 */
import "./style/common.less";

import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
// 语言切换
const i18n = new VueI18n({
  locale: 'en', // 语言标识
  messages: {
    'zh': require('@/lang/zh'),
    'en': require('@/lang/en')
  }
})

import notification from 'ant-design-vue/es/notification';

//全局错误提示 解决错误提示多次弹出
window.notification = {
  error: (options) => {
    let localeOpt = {
      // btn:function(h){
      //   return (<span></span>)
      // }
    }

    let opt = Object.assign({}, localeOpt, options);
    let dom = document.querySelector('.ant-notification-notice');
    //如果错误提示已经弹出 则不提示

    if (dom) return;
    notification.error(opt)
  }
}
new Vue({
  router,
  store,
  i18n,
  Api,
  http,
  mounted() {
    //获取token
    // store.commit('SET_TOKEN', Vue.ls.get('AuthToken'))
    // store.commit('SET_USER', Vue.ls.get('AuthUser'))
    store.commit('setState', {
      key: 'emailIsVerified',
      value: Vue.ls.get('emailIsVerified') || false
    })
  },
  render: h => h(App),
  data: {
    Bus: new Vue()
  }
}).$mount('#app')